import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { fromJson } from '@client/core/data/concerns/parses-from-json/from-json';
import { ProjectStatus } from '@client/features/project/models/project-status';
import { User } from '@client/features/user/models/user';
import { isObject } from '@client/core/utils/is-object';

/**
 * Partial data from Project
 */
interface ProjectCardProject {
  id: number;
  uuid: string;
  name: string;
  strategyText: string;
  fullAddress: string;
  stage: string;
}

/**
 * Data to render VueJS <ProjectCard>
 */
export class ProjectCard {
  constructor(
    public readonly project: ProjectCardProject,
    public readonly propertyImageUrl: string,
    // User.id's with access to this Project
    public readonly teamIds: Array<number>,
    public readonly latestStatus: null | ProjectStatus,
    public readonly userCanAccessProject: boolean,
  ) {}

  team(members: null | Record<string, object>): Array<User> {
    // const members = getAppConfig().workspaceMembers;
    if (!members || !isObject(members)) {
      return [];
    }

    return this.teamIds
      .map((userId) =>
        Object.getOwnPropertyNames(members).includes(String(userId)) ? members[String(userId)] : undefined,
      )
      .filter((user) => undefined !== user)
      .map((userObj) => fromJson(User, userObj));
  }
}

defineTransform(ProjectCard, (json, { fromSnakeCaseKeys, nullOr }) => {
  const project: ProjectCardProject = {
    id: json.project.id,
    uuid: json.project.uuid,
    name: json.project.name,
    fullAddress: json.project.full_address,
    strategyText: json.project.strategy_text,
    stage: json.project.stage,
  };

  return {
    ...fromSnakeCaseKeys(),
    project,
    latestStatus: nullOr(json.latest_status, () => fromJson(ProjectStatus, json.latest_status)),
  };
});
